
<div class="OpacitySlider">
  <label>Opacity: {{ value }}%</label>
  <input
    type="range"
    min="10"
    max="90"
    step="10"
    v-bind:value="value"
    v-on:input="setValue"
  />
</div>
